module.exports = __webpack_public_path__ + "static/media/Statement_of_Accounts_2020.d723dc4a.pdf";